import AmexCenturionNYEventCard from './AmexCenturionNYEventCard';

export default AmexCenturionNYEventCard;
